var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FF5A59",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1133.17 1844.902c-.429 0-.819-.078-1.17-.273V1873h25.756v-28.37c-.351.155-.741.272-1.17.272h-23.415zm18.732 7.688v4.41c0 3.863-3.16 7.024-7.024 7.024-3.863 0-7.024-3.16-7.024-7.024v-4.41c-1.132-.351-1.952-1.366-1.952-2.614 0-1.522 1.21-2.732 2.732-2.732 1.522 0 2.732 1.21 2.732 2.732 0 1.248-.82 2.263-1.951 2.614v4.41c0 3.005 2.458 5.463 5.463 5.463s5.463-2.458 5.463-5.463v-4.41c-1.131-.351-1.95-1.366-1.95-2.614 0-1.522 1.209-2.732 2.73-2.732 1.523 0 2.733 1.21 2.733 2.732 0 1.248-.82 2.263-1.952 2.614zm-13.268-1.444c-.663 0-1.17-.546-1.17-1.17 0-.664.507-1.171 1.17-1.171.664 0 1.17.507 1.17 1.17 0 .625-.506 1.171-1.17 1.171zm-6.634-8.975c0-.664.507-1.171 1.17-1.171h23.415c.664 0 1.171.507 1.171 1.17 0 .625-.507 1.171-1.17 1.171h-23.415c-.664 0-1.171-.546-1.171-1.17zm20.293 7.805c0 .624-.508 1.17-1.171 1.17s-1.17-.546-1.17-1.17c0-.664.507-1.171 1.17-1.171.663 0 1.17.507 1.17 1.17z",
    transform: "translate(-1132 -1841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEcommerce);
export default __webpack_public_path__ + "static/media/icon-ecommerce.733fe843037a81a5423c5d471c29e2ce.svg";
export { ForwardRef as ReactComponent };